<script setup lang="ts">
import ConsolidationCard from '@/components/dashboard/home/ConsolidationCard.vue'

const emit = defineEmits<{
  upgrade: []
}>()
</script>

<template>
  <div class="sa-page-stack">
    <section aria-labelledby="free-consolidation-heading">
      <div class="sa-section-hd">
        <h2 id="free-consolidation-heading" class="sa-section-title">
          {{ $t('Dashboard.Home.Consolidation.SectionHeading') }}
        </h2>
      </div>
      <ConsolidationCard @upgrade="emit('upgrade')" />
    </section>
  </div>
</template>
